import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LoadingComponent from '../common/loading.component';
import MainPageComponent from '../_generic/main.page.component';
import SessionListComponent from './overview/sessionList.component';
import { fetchSessions, updateSessionHide } from '../../store/actions/session.actions';
import { fetchSettings, updateSettingsHideArchivedFiles} from '../../store/actions/settings.actions'

class SessionContainer extends React.Component {
  constructor(props) {
    super(props);

    this.refreshSessions = this.refreshSessions.bind(this);
    this.refreshSettings = this.refreshSettings.bind(this);
    this.hideSession = this.hideSession.bind(this);
    this.hideArchivedSessions = this.hideArchivedSessions.bind(this);
    this.state = {
      isFetching: true
    }
  }

  componentDidMount() {
    this.props.fetchSessions();
    this.props.fetchSettings();
    this.setState({
      isFetching: false
    })

  }

  refreshSessions() {
    this.props.fetchSessions();
  }
  refreshSettings() {
    this.props.fetchSettings();
  }

  hideSession(sessionId,hide) {
    this.props.updateSessionHide(sessionId,hide);
  }
  hideArchivedSessions(hide) {
    this.props.updateSettingsHideArchivedFiles(hide);
  }

  render() {
    if (this.props.isFetchingSessions) {
      return <LoadingComponent />;
    }

    return (
      <MainPageComponent title="Projects">
        {this.state.isFetching?'':<SessionListComponent
          sessions={this.props.sessions}
          currentSessionId={this.props.currentSessionId}
          currentFileId={this.props.currentFileId}
          refreshSessions={this.refreshSessions}
          refreshSettings={this.refreshSettings}
          hideSession={this.hideSession}
          hideArchivedSessions={this.hideArchivedSessions}
          settings={this.props.settings}
        />}
      </MainPageComponent>
    );
  }
}

SessionContainer.propTypes = {
  sessions: PropTypes.shape({
    id: PropTypes.string,
    createdAt: PropTypes.number,
    lastModified: PropTypes.number,
    name: PropTypes.string,
    hide: PropTypes.bool,
    files: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
      lastModified: PropTypes.number,
      savedByUser: PropTypes.bool,
    })),
  }).isRequired,
  settings: PropTypes.shape({
    hideArchivedSessions: PropTypes.bool,
  }),
  isFetchingSessions: PropTypes.bool.isRequired,
  fetchSessions: PropTypes.func.isRequired,
  fetchSettings: PropTypes.func.isRequired,
  updateSettingsHideArchivedFiles: PropTypes.func.isRequired,
  currentSessionId: PropTypes.string.isRequired,
  currentFileId: PropTypes.string.isRequired,
  updateSessionHide: PropTypes.func.isRequired,
};

const mapStateToProps = ({
  sessions,
  settings,
  status: {
    isFetchingSessions,
    currentSessionId,
    currentFileId,
  },
}) => ({
  sessions,
  settings,
  isFetchingSessions,
  currentSessionId,
  currentFileId,
});

export default connect(mapStateToProps, { fetchSessions, updateSessionHide, fetchSettings, updateSettingsHideArchivedFiles })(SessionContainer);
